module.exports = __webpack_public_path__ + "img/D.cdd552b2.png";